var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3502_46068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.33333 9.16634V15.833C6.33333 16.054 6.24554 16.266 6.08926 16.4223C5.93298 16.5785 5.72101 16.6663 5.5 16.6663M6.33333 9.16634H3.83333C3.61232 9.16634 3.40036 9.25414 3.24408 9.41042C3.0878 9.5667 3 9.77866 3 9.99967V15.833C3 16.054 3.0878 16.266 3.24408 16.4223C3.40036 16.5785 3.61232 16.6663 3.83333 16.6663H5.5M6.33333 9.16634C7.21739 9.16634 8.06524 8.81515 8.69036 8.19003C9.31548 7.56491 9.66667 6.71706 9.66667 5.83301V4.99967C9.66667 4.55765 9.84226 4.13372 10.1548 3.82116C10.4674 3.5086 10.8913 3.33301 11.3333 3.33301C11.7754 3.33301 12.1993 3.5086 12.5118 3.82116C12.8244 4.13372 13 4.55765 13 4.99967V9.16634H15.5C15.942 9.16634 16.366 9.34194 16.6785 9.6545C16.9911 9.96706 17.1667 10.391 17.1667 10.833L16.3333 14.9997C16.2135 15.5109 15.9861 15.9499 15.6855 16.2505C15.3849 16.5511 15.0274 16.697 14.6667 16.6663H5.5M5.5 16.6663L6.3165 16.6017V15.9997C6.3165 15.9997 6.33333 14.8294 6.33333 14.1663",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3502_46068"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/Like.975020321b8bc0b58d2989048d6aceaa.svg";
export { ForwardRef as ReactComponent };